export default "__VITE_ASSET__7AIT1wbR__"